<template>
  <table class="unstriped hover boss-table">
    <thead>
      <tr>
        <th class="boss-table-head-center">
          求人ID
        </th>
        <th class="boss-table-head-center">
          管理用求人名
        </th>
        <th class="boss-table-head-center">
          求人名
        </th>
        <th class="boss-table-head-center">
          掲載期間
        </th>
        <th class="boss-table-head-center">
          掲載サイズ
        </th>
        <th class="boss-table-head-center">
          プレビュー
        </th>
        <th class="boss-table-head-center">
          応募フォームタイプ
          <a
            target="_blank"
            class="pega-circle"
            data-test="entry-form-type-link"
            href="/help/faq/index_282.html"
          >!</a>
        </th>
      </tr>
    </thead>
    <tbody>
      <job-published-job
        v-for="(job, i) in jobs"
        :key="i"
        :job="job"
        v-on="$listeners"
      />
    </tbody>
  </table>
</template>

<script>
import JobPublishedJob from '@/components/molecules/JobPublishedJob'

export default {
  components: {
    JobPublishedJob
  },
  props: {
    jobs: {
      type: Array,
      required: true
    }
  }
}
</script>
